var $ = require('jquery');
var Masonry = require('masonry-layout');

$.fn.visible = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

/**
 * Document Ready
 */
$(function () {

    if ( $('.masonry-grid-with-filter').length !== 0 ) {

        /**
         * Masonry Methods
         */
        window.MasonryJS = {

            initialize: function(refresh, gridElem) {
                refresh = (typeof refresh === 'undefined') ? false : refresh;

                if (refresh === false) {
                    gridElem.find('.grid-item:first-child').first().addClass('featured-item');
                }

                if ( gridElem.find('.grid-sizer').length === 0 ) {
                    if ( gridElem.find('.grid-item:nth-child(2)').length ) {
                        gridElem.find('.grid-item:nth-child(2)').addClass('grid-sizer');
                    } else {
                        gridElem.find('.grid-item:first-child').addClass('grid-sizer');
                    }
                }

                var elem = gridElem[0].querySelector('.masonry-grid-container');
                var gridTileWidth = elem.querySelectorAll('.grid-sizer')[0];

                var msnry = new Masonry( elem, {
                    percentPosition: true,
                    columnWidth: '.grid-sizer',
                    itemSelector: '.grid-item'
                });

                if ( gridElem.find('.loading').length === 0 ) {
                    var imgSrc = '/assets/images/dual-ring-loader-blue-3s-120px.gif';
                    gridElem.find('.container-fluid').append(
                        '<div class="loading masonry-loader">' +
                          '<img src="'+imgSrc+'" width="120" height="120" alt="loading gif" />' +
                        '</div>'
                    );
                }

                return msnry;
            },

            refreshGrid: function(gridElem) {
                masonryGridAnimations = new MasonryJS.initialize(true, gridElem);
            },

            animations: function() {

                /**
                 * jQuery.visible Alternative
                 *
                 * @ link stackoverflow.com/questions/487073/check-if-element-is-visible-after-scrolling
                 */
                $.fn.visible = function() {
                    var elementTop = $(this).offset().top;
                    var elementBottom = elementTop + $(this).outerHeight();

                    var viewportTop = $(window).scrollTop();
                    var viewportBottom = viewportTop + $(window).height();

                    return elementBottom > viewportTop && elementTop < viewportBottom;
                };

                /* If element is scrolled into view, fade it in */
                $(window).on('scroll', function() {
                    $('.animated.inactive').each(function() {
                        var me = $(this);
                        var animateIn = me.data('animation') || 'fadeInUp fast',
                            animateOut = me.data('animation-out') || false;
                        if (me.visible(true)) {
                            me.addClass(animateIn + ' active').removeClass('inactive').removeClass(animateOut);
                            if (me.data('remove-animated-class')) {
                                var animationLength = ((parseFloat(getComputedStyle(me[0]).animationDuration)) || 0) * 1000;
                                if (animationLength >= 0) {
                                    setTimeout(function() {
                                        me.removeClass('animated');
                                    }, (animationLength + 200));
                                }
                            }
                        }
                    });
                });
            }
        };

        $('.masonry-grid-with-filter').each(function () {
            var currentModule = $(this);
            var masonryGridModule = new MasonryJS.initialize(false, currentModule);
        });

        $(window).on('resize', function () {
            $('.masonry-grid-with-filter').each(function () {
                var currentModule = $(this);
                MasonryJS.refreshGrid(currentModule);
            });
        });

        var masonryGridAnimations = new MasonryJS.animations();
    }
});

/**
 * Window Load
 */
$(window).on('load', function () {
    if ( $('.masonry-grid-with-filter').length !== 0 ) {
        $(window).trigger('scroll');
    }
});
